import Icon from '../Icon/Icon';

// TODO: Replace with the correct icon once provided by design.
const BadgeActionCompleteIcon = ({className}: {className?: string}) => (
    <Icon width='40' height='40' fill='none' className={className}>
        <circle cx='20' cy='20' r='20' fill='#3AC9F3' />
        <path
            d='M12 21.0543L16.5244 25.7895L28 14'
            stroke='#34303D'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </Icon>
);

export default BadgeActionCompleteIcon;
